import { createSlice } from "@reduxjs/toolkit";

const plinkoInflightBallsSlice = createSlice({
  name: "plinkoInflightBalls",
  initialState: {
    count: 0,
  },
  reducers: {
    setInflightBallsCount(state, action) {
      const n = Number(action.payload) || 0;
      state.count = Math.max(0, n);
    },
    resetInflightBallsCount(state) {
      state.count = 0;
    },
  },
});

export const { setInflightBallsCount, resetInflightBallsCount } =
  plinkoInflightBallsSlice.actions;

export default plinkoInflightBallsSlice.reducer;
